(function () {
  const CART_ITEMS_SELECTOR = '[data-naturrum-cart-configurator-items]';
  const CHECKOUT_SELECTOR = '#checkout, button[name="checkout"], [name="checkout"], a[href*="/checkout"]';
  const GA4_MEASUREMENT_ID = 'G-C34P5T4LXG';
  const TRACKED_ATTR = 'naturrumConfiguratorCheckoutTracked';

  function readConfiguredItems() {
    const script = document.querySelector(CART_ITEMS_SELECTOR);
    if (!script?.textContent) return [];

    try {
      const items = JSON.parse(script.textContent);
      return Array.isArray(items) ? items.filter((item) => item?.configuration_id) : [];
    } catch {
      return [];
    }
  }

  function productPayload(item) {
    return {
      product_id: item.product_id || null,
      product_handle: item.product_handle || null,
      product_title: item.product_title || null,
      product_family: 'specialmaal',
    };
  }

  function configurationPayload(item) {
    return {
      price_group: item.price_group || null,
      price_interval: item.price_interval || null,
      production_measure: item.production_measure || null,
      shown_price_dkk: item.final_price_dkk || null,
      quantity: item.quantity || 1,
      variant_id: item.variant_id || null,
      is_valid_configuration: true,
    };
  }

  function analyticsApi() {
    return window.NaturrumConfiguratorAnalytics || null;
  }

  function hasAnalyticsConsent() {
    const api = analyticsApi();
    const consent = api?.readConsent?.(window);
    return consent?.analytics === true;
  }

  function primeGa4Transport() {
    if (!hasAnalyticsConsent()) return false;
    if (window.NATURRUM_CONFIGURATOR_GA4_LOADED === true) return true;

    window.dataLayer = Array.isArray(window.dataLayer) ? window.dataLayer : [];

    if (typeof window.gtag !== 'function') {
      window.gtag = function gtag() {
        window.dataLayer.push(Array.from(arguments));
      };
    }

    const hasGa4Loader = Array.from(document.scripts || []).some((script) => (
      typeof script.src === 'string'
      && script.src.includes('googletagmanager.com/gtag/js')
      && script.src.includes(GA4_MEASUREMENT_ID)
    ));

    if (!hasGa4Loader && document.head?.appendChild && document.createElement) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
      document.head.appendChild(script);
    }

    window.gtag('js', new Date());
    window.gtag('config', GA4_MEASUREMENT_ID, { send_page_view: false });
    window.NATURRUM_CONFIGURATOR_GA4_LOADED = true;
    return true;
  }

  function primeAnalyticsConsent() {
    const api = analyticsApi();
    api?.primeCustomerPrivacyApi?.(window);
    primeGa4Transport();

    const loadPromise = api?.loadCustomerPrivacyApi?.(window);
    if (loadPromise?.then) {
      loadPromise.then(() => {
        primeGa4Transport();
      });
    }
  }

  function trackCheckoutStarted(item, index, trigger) {
    const api = analyticsApi();
    if (!api?.track) return null;

    return api.track('naturrum_configured_checkout_started', {
      configuration_id: item.configuration_id,
      product: productPayload(item),
      configuration: configurationPayload(item),
      context: {
        source: 'cart_checkout_button',
        trigger,
        line_index: index,
        price_shown_event_id: item.price_shown_event_id || null,
      },
    });
  }

  function isElement(value) {
    return value instanceof HTMLElement;
  }

  function checkoutTriggerFromEvent(event) {
    const targetTrigger = event.target?.closest?.(CHECKOUT_SELECTOR);
    if (isElement(targetTrigger)) return targetTrigger;

    if (isElement(event.submitter) && event.submitter.matches?.(CHECKOUT_SELECTOR)) {
      return event.submitter;
    }

    return null;
  }

  function trackConfiguredCheckout(event, trigger) {
    const checkoutTrigger = checkoutTriggerFromEvent(event);
    if (!checkoutTrigger) return;
    if (checkoutTrigger.dataset[TRACKED_ATTR] === 'true') return;

    primeAnalyticsConsent();

    const items = readConfiguredItems();
    if (items.length === 0) return;

    const trackedEvents = items.map((item, index) => trackCheckoutStarted(item, index, trigger));
    if (trackedEvents.some(Boolean)) {
      checkoutTrigger.dataset[TRACKED_ATTR] = 'true';
    }
  }

  function bindCheckoutTracking() {
    primeAnalyticsConsent();

    document.addEventListener('pointerdown', (event) => {
      trackConfiguredCheckout(event, 'pointerdown');
    }, { capture: true });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      trackConfiguredCheckout(event, 'keydown');
    }, { capture: true });

    document.addEventListener('click', (event) => {
      trackConfiguredCheckout(event, 'click');
    }, { capture: true });

    document.addEventListener('submit', (event) => {
      trackConfiguredCheckout(event, 'submit');
    }, { capture: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCheckoutTracking, { once: true });
  } else {
    bindCheckoutTracking();
  }
})();
